<template>
  <div class="lines-bg py-40 flex items-center justify-center">
    <div class="relative bg-white border-4 border-blue rounded-lg px-8 pb-12 w-full max-w-2xl">
      <div class="relative form-title flex z-20 -ml-2">
        <h2 class="w-auto bg-blue text-white text-xl uppercase font-bold px-2 py-1 rounded">My Main Event</h2>
      </div>
      <div class="px-2">
        <!-- <div class="flex border-b-2 border-black pb-6 mb-4">
          <div class="mr-2">
            <nuxt-link to="/account" class="button pink">Your Account</nuxt-link>
          </div>
          <div>
            <nuxt-link to="/account/password" class="button pink">Change Password</nuxt-link>
          </div>
        </div> -->
        <h3 class="uppercase font-bold text-xl ">Account Details</h3>
      </div>
      <form-main
        :fields="fields"
        :labels="true"
        :values="defaults"
        :errors="errors"
        submitText="Update"
        submitColor="purple"
        submitAlign="left"
        :handleSubmit="updateAccount"
        cancelText="Log Out"
        cancelColor="pink"
        :handleCancel="logOut" />
      <div v-if="loading" class="absolute inset-0 flex items-center rounded-lg justify-center bg-white-95">
        <loader color="purple" />
      </div>
      <div v-else-if="error" class="absolute inset-0 flex items-center rounded-lg justify-center bg-white-95 uppercase text-center">
        Error contacting server.<br />Please refresh and try again.
      </div>
      <div v-else-if="success" class="px-2 pt-2">
        Your account has been updated!
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '~/components/common/Loader'
import FormMain from '~/components/forms/FormMain'
const fields = require('~/assets/config/accountDetails.json')

export default {
  components: {
    Loader,
    FormMain
  },
  data() {
    return {
      loading: true,
      error: false,
      success: false,
      fields: fields,
      defaults: {},
      errors: []
    }
  },
  head() {
    return {
      title: 'My Account'
    }
  },
  async beforeMount() {
    let token = await this.$okta.getLogin()
    if(!token) {
      this.$router.push('/login')
    } else {
      this.$store.commit('setLogInState', true)
      if(!this.$store.state.account) {
        this.$mulesoftv3.getAccount()
        .then(res => {
          this.$store.commit('setAccount', res.data.accounts[0])
          this.setDefaults()
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            me_account: res.data.accounts[0]
          })
        }).catch(err => {
          this.loading = false
          this.error = true
          this.$router.push('/login')
          // console.error(err)
        })
      } else {
        this.setDefaults()
      }
      setTimeout(() => {
        let redirect = localStorage.getItem('me_redirect')
        if(redirect) {
          localStorage.removeItem('me_redirect')
          this.$router.push(redirect)
        }
      }, "1000");
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.loggedIn
    },
    account() {
      return this.$store.state.account
    }
  },
  methods: {
    setDefaults() {
      let defaults = {}
      this.fields.map(f => {
        defaults[f.fields.name] = this.$store.state.account[f.fields.name]
      })
      this.defaults = defaults
      this.loading = false
    },
    async logOut() {
      this.loading = true
      this.$okta.logOut()
    },
    async updateAccount() {
      if(this.validate()) {
        let id = this.$store.state.account.accountId
        this.loading = true
        this.error = await this.$mulesoftv3.updateAccount(id, Object.assign({
          accountId: id
        }, this.defaults))
          .then(res => {
            this.success = true
            let updated = Object.assign({}, this.$store.state.account, this.defaults)
            this.$store.commit('setAccount', updated)
            return false
          }).catch(err => {
            console.error(err)
            return true
          })
        this.loading = false
      }
    },
    validate() {
      this.errors = []
      Object.keys(this.defaults).map(k => {
        switch(k) {
          case 'phone1':
            if(!this.defaults[k].match(/^[\(]?[1-9]{1}[0-9]{2}[\)\s\-\.]*[1-9]{1}[0-9]{2}[\s\-\.]?[0-9]{4}/)) {
              this.errors.push(k)
            }
            break
          case 'email':
            if(!this.defaults[k].match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
              this.errors.push(k)
            }
            break
          default:
            if(!this.defaults[k].match(/[a-zA-Z]+/)) {
              this.errors.push(k)
            }
        }
      })
      return this.errors.length > 0 ? false : true
    }
  }
}
</script>

<style lang="scss" scoped>
.form-title {
  transform: translateY(-50%);
}
.nuxt-link-active {
  background: white;
  color: black;
}
</style>